// 在线文档
import React, {memo} from 'react'
import LinkImg from "../../img/fileTypes/link.png"
import styled from 'styled-components'

const DocMsg = styled.div`
  width: 268px;
  height: 56px;
  color: #595959;
  border: 1px solid #D9D9D9;
  font-size: 12px;
  display: flex;
  padding: 8px;
  margin-top: 8px;
  cursor: pointer;
  .fileImg {
    width: 40px;
    height: 40px;
    border-radius: 2px;
  }
  .doc-title {
    height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 18px;
    margin-left: 8px;
  }
`

const RenderLinkMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return(
    <DocMsg onClick={()=>window.open(message.linkUrl)}>
      <img className={'fileImg'} src={message.imageUrl || LinkImg} alt=""/>
      <div className={'doc-title'}>{message.title}</div>
    </DocMsg>
  )
})

export default RenderLinkMsg;